export const API_URL = process.env.REACT_APP_API_URL;
export const COOKIE_URL = "sanctum/csrf-cookie";
export const CODE_FISCALE_URL = "https://api.miocodicefiscale.it";
export const PROCESS_MATCHING_TIME = process.env.REACT_APP_PROCESS_MATCHING_TIME;
export const CANCEL_WORD = process.env.REACT_APP_CANCEL_WORD;
export const MIOCODICEFISCALE_TOKEN = process.env.REACT_APP_MIOCODICEFISCALE_TOKEN;
export const RETRY_LINK_ATTEMPTS_MAX = process.env.REACT_APP_APOLLO_RETRY_LINK_ATTEMPTS_MAX;
export const RETRY_LINK_DELAY_INITIAL = process.env.REACT_APP_APOLLO_RETRY_LINK_DELAY_INITIAL;
export const PASSWORD_MIN_LENGTH = 8;
// export const PREFIXES = [
//   { value: "+39", label: "+39" },
// ];
